import React from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import s from './GroupCard.scss';
var GroupCard = function (_a) {
    var username = _a.username, imageUrl = _a.imageUrl, className = _a.className, biData = _a.biData;
    return (React.createElement(BiLink, { href: Url.userLink(username), className: classnames(s['root'], className), biData: biData },
        React.createElement("div", { className: s['img-wrap'] }, imageUrl && React.createElement("img", { src: imageUrl, alt: "", loading: "lazy" })),
        React.createElement("div", { className: s['name'] }, username)));
};
GroupCard.displayName = 'GroupCard';
export default GroupCard;
//# sourceMappingURL=GroupCard.js.map